export enum RESTAURANT_TYPES {
    BAKERY = "Bakery",
    BAR_FOOD = "Bar & Food",
    FAST_FOOD = "Fast Food",
    FAST_CASUAL = "Fast Casual",
    FINE_DINING = "Fine Dining",
}
